export const path = '/socket/socket.io';
